define('shoptheme/components/blocks/elements/product/item/pane',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"gigaset/spinner",
	"select2"
], function(
	$,
	Component,
	BEM,
	Spinner,
	s2
) {
	var BLOCK_NAME = "elements-product-item-pane";

	return Component.create({
		blocks:			null,

		$init: function() {
			var self = this;
			this.blocks = BEM.block(BLOCK_NAME);

			this.blocks.each(function() {
				var block = BEM.block(this),
					detailsWrap = block.getElements("details-wrap"),
					detailsWrapHelper = block.getElements("details-wrap-helper"),
					detailsWrapSlot = block.getElements("details-wrap-slot"),
					animationSpeedMs = 500,
					detailsWrapHeight = 0;

				self.initQtyBlock(block);

				block.on("click", "." + BEM.buildElementClassname(BLOCK_NAME, "cta-link", "js-load-details"), function(e) {
					var link = $(e.target),
						href = link.data("ajax-tabs-url");

					if (!href) return true;

					e.preventDefault();

					if (detailsWrap.bemHasModifier("empty")) {
						block.bemAddModifier("loading");

						Spinner.add(detailsWrapHelper);
						detailsWrapHeight = detailsWrapHelper.outerHeight();
						detailsWrap.bemRemoveModifier("empty");
						detailsWrap.bemAddModifier("visible");
						detailsWrap.css('height', detailsWrapHeight);

						var xhr = $.get(href);

						xhr.then(function() {
							Spinner.remove(detailsWrapHelper);
							block.bemRemoveModifier("loading");
						});

						xhr.done(function(response) {
							detailsWrapSlot.html("");

							var tabs = "tabs" in response ? response.tabs : {};
							var key, element;

							for (key in tabs) {
								if (tabs.hasOwnProperty(key)) {
									element = $('<div class="' + BEM.buildElementClassname(BLOCK_NAME, "details-content") + " " + BEM.buildElementClassname(BLOCK_NAME, "details-content", key) + '" />');
									element.html(tabs[key]);
									element.appendTo(detailsWrapSlot);
								}
							}

							detailsWrapHeight = detailsWrapHelper.outerHeight();
							detailsWrap.bemRemoveModifier("empty");
							detailsWrap.bemAddModifier("visible");
							detailsWrap.css('height', detailsWrapHeight);
							setTimeout(function(){detailsWrap.css('height', 'auto')}, animationSpeedMs);
						});
					} else {
						if (detailsWrap.bemHasModifier("visible")) {
							detailsWrapHeight = detailsWrapHelper.outerHeight();
							detailsWrap.css('height', detailsWrapHeight);
							setTimeout(function(){detailsWrap.css('height', 0)}, 10);
							setTimeout(function(){detailsWrap.bemRemoveModifier("visible")}, 500);
						} else {
							detailsWrapHeight = detailsWrapHelper.outerHeight();
							detailsWrap.bemAddModifier("visible");
							detailsWrap.css('height', detailsWrapHeight);
							setTimeout(function(){detailsWrap.css('height', 'auto')}, animationSpeedMs);
						}
					}
				});

				block.on("click", "." + BEM.buildElementClassname(BLOCK_NAME, "cta-link", "js-hide-details"), function(e) {
					e.preventDefault();
					detailsWrapHeight = detailsWrapHelper.outerHeight();
					detailsWrap.css('height', detailsWrapHeight);
					setTimeout(function(){detailsWrap.css('height', 0); jQuery('html,body').animate({ scrollTop: $('body').scrollTop() - detailsWrapHeight }, animationSpeedMs);}, 10);
					detailsWrap.bemRemoveModifier("visible");
				});
			});
			
		},
		
		initQtyBlock: function(block) {
			var qtyBlocks = BEM.block('product-qty', block);
			qtyBlocks.each(function(){
				var qtyBlock = BEM.block(this),
					lessLink = qtyBlock.getElements('less-link'),
					moreLink = qtyBlock.getElements('more-link'),
					qtySelect = qtyBlock.getElements('select');

				qtySelect.select2({	minimumResultsForSearch: Infinity });
				lessLink.click(function(e){
					e.preventDefault();
					if (qtySelect.find('option:selected').prev().val()) {
						qtySelect.select2().val(qtySelect.find('option:selected').prev().val()).trigger('change');
					}
				});
				moreLink.click(function(e){
					e.preventDefault();
					if (qtySelect.find('option:selected').next().val()) {
						qtySelect.select2().val(qtySelect.find('option:selected').next().val()).trigger('change');
					}
				});

				qtySelect.on('change', function(){
					block.find('[data-ajax-add-to-cart]').data('order-qty', this.value);
				});

			});
		}
	});
});
